import { FinComponent } from './fin.component';
import { FinRoutingModule } from './fin-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { LookupsModule } from '../lookups/lookups.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ModalContainerService, ModalService } from 'yt-ng-framework';
import { FinDokumentTabsComponent } from './nalog/fin-dokument-tabs.component';
import { FinDokumentTabUpdateComponent } from './nalog/fin-dokument-tab-update.component';
import { FinDokumentStavkaUpdateComponent } from './nalog/fin-dokument-stavka-update.component';
import { FinDokumentStavkaModalUpdateComponent } from './nalog/fin-dokument-stavka-modal-update.component';
import { FinDokumentUpdateComponent } from './nalog/fin-dokument-update.component';
import { FinDokumentStavkaUpdateContainer } from './nalog/fin-dokument-stavka-update-container.component';
import { FinDokumentStavkaInlineUpdateComponent } from './nalog/fin-dokument-stavka-inline-update.component';
import { KozDokumentUpdateComponent } from './koz/koz-dokument-update.component';
import { KozDokumentStavkaUpdateComponent } from './koz/koz-dokument-stavka-update.component';
import { KozDokumentTabUpdateComponent } from './koz/koz-dokument-tab-update.component';
import { KozDokumentTabsComponent } from './koz/koz-dokument-tabs.component';
import { KozDokumentStavkaModalUpdateComponent } from './koz/koz-dokument-stavka-modal-update.component';
import { KozDokumentStavkaUpdateContainer } from './koz/koz-dokument-stavka-update-container.component';
import { KozDokumentStavkaInlineUpdateComponent } from './koz/koz-dokument-stavka-inline-update.component';
import { IzvodStavkaInlineUpdateComponent } from './izvod/izvod-stavka-inline-update.component';
import { IzvodStavkaModalUpdateComponent } from './izvod/izvod-stavka-modal-update.component';
import { IzvodStavkaUpdateComponent } from './izvod/izvod-stavka-update.component';
import { IzvodTabUpdateComponent } from './izvod/izvod-tab-update.component';
import { IzvodTabsComponent } from './izvod/izvod-tabs.component';
import { IzvodUpdateComponent } from './izvod/izvod-update.component';
import { IzvodStavkaUpdateContainerComponent } from './izvod/izvod-stavka-update-container.component';
import { IzvodSumComponent } from './izvod/izvod-sum.component';
import { FinDokumentSumComponent } from './nalog/fin-dokument-sum.component';
import { RekapitulacijaIzvodaComponent } from './_reports/rekapitulacija-izvoda/rekapitulacija-izvoda.component';
import { RekapitulacijaPoKomitentimaComponent } from './_reports/rekapitulacija-po-komitentima/rekapitulacija-po-komitentima.component';
import { FilterWithBankaComponent } from './_filters/filter-with-banka.component';
import { UvozIzvodaComponent } from './izvod/uvoz-izvoda.component';
import { DefaultFilter } from '../lookups/default-filter/default-filter.component';
import { FakModule } from '../fak/fak.module';


@NgModule({
  imports: [
    FinRoutingModule,
    LookupsModule,
    NgbModule,
    TranslateModule,
    FakModule
  ],
  declarations: [HomeComponent, FinComponent
    , FinDokumentTabsComponent
    , FinDokumentTabUpdateComponent
    , FinDokumentStavkaUpdateComponent
    , FinDokumentStavkaModalUpdateComponent
    , FinDokumentUpdateComponent
    , FinDokumentStavkaUpdateContainer
    , FinDokumentStavkaInlineUpdateComponent
    , KozDokumentTabsComponent
    , KozDokumentTabUpdateComponent
    , KozDokumentStavkaUpdateComponent
    , KozDokumentUpdateComponent
    , KozDokumentStavkaModalUpdateComponent 
    , KozDokumentStavkaUpdateContainer
    , KozDokumentStavkaInlineUpdateComponent
    , IzvodStavkaInlineUpdateComponent
    , IzvodStavkaModalUpdateComponent
    , IzvodStavkaUpdateComponent
    , IzvodTabUpdateComponent
    , IzvodTabsComponent
    , IzvodUpdateComponent, IzvodStavkaUpdateContainerComponent, IzvodSumComponent
    , FinDokumentSumComponent
    , RekapitulacijaIzvodaComponent
    , RekapitulacijaPoKomitentimaComponent
    , FilterWithBankaComponent
    , UvozIzvodaComponent
    
  ]
  ,exports:[
    FinDokumentTabsComponent
    , FinDokumentTabUpdateComponent
    , FinDokumentUpdateComponent
    , FinDokumentStavkaUpdateComponent
    , KozDokumentTabsComponent
    , KozDokumentTabUpdateComponent
    , KozDokumentUpdateComponent
    , KozDokumentStavkaUpdateComponent
    , IzvodUpdateComponent
    , IzvodTabUpdateComponent
    , IzvodStavkaUpdateComponent
  ]  
  // ,
  // entryComponents:[
  //   FinDokumentStavkaModalUpdateComponent
  //   , KozDokumentStavkaModalUpdateComponent    
  //   , IzvodStavkaModalUpdateComponent
  //   , FilterWithBankaComponent
  //   , UvozIzvodaComponent
  //   , DefaultFilter
  // ]
  ,providers:[
    ModalContainerService,
    ModalService
  ]
})
export class FinModule { }
